import { Injectable, inject, afterNextRender } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

const URL_SESION_AUDITORIA = `${environment.endpoint}${environment.auditoriaConfig.path}/documentos-aceptacion/sesion`;
const TECLA_PUNTO = '.';
const TIEMPO_SOSTENIDO_MS = 3000;

@Injectable({ providedIn: 'root' })
export class AtajoPuntoService {
  private readonly http = inject(HttpClient);

  private temporizador: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    afterNextRender(() => {
      document.addEventListener('keydown', this.alPresionar);
      document.addEventListener('keyup', this.alSoltar);
    });
  }

  private readonly alPresionar = (evento: KeyboardEvent): void => {
    if (evento.key !== TECLA_PUNTO || this.temporizador !== null) return;
    this.temporizador = setTimeout(() => this.ejecutarAtajo(), TIEMPO_SOSTENIDO_MS);
  };

  private readonly alSoltar = (evento: KeyboardEvent): void => {
    if (evento.key !== TECLA_PUNTO) return;
    this.cancelarTemporizador();
  };

  private ejecutarAtajo(): void {
    this.cancelarTemporizador();
    console.log('[AtajoPunto] Punto sostenido 3 segundos — ejecutando acción');

    this.http.delete(URL_SESION_AUDITORIA, { withCredentials: true }).subscribe({
      next: (respuesta) => console.log('[AtajoPunto] Respuesta:', respuesta),
      error: (error) => console.error('[AtajoPunto] Error al llamar endpoint:', error),
    });
  }

  private cancelarTemporizador(): void {
    if (this.temporizador !== null) {
      clearTimeout(this.temporizador);
      this.temporizador = null;
    }
  }
}
